import {UmpireCompetitionSeason} from '../umpire-competition-season';
import {UmpireExternalProviderPointer} from '../umpire-external-provider-pointer';

export interface UmpireCompetition {
  type: string;

  id: string;

  name: string | null;

  slug: string | null;

  external_provider_pointers: UmpireExternalProviderPointer[];

  competition_seasons: UmpireCompetitionSeason[];
}
